import Document from "../../../components/Document";

const DocumentRegisters = () => {
  return (
    <>
      <Document description="Safety Data Sheet"/>
    </>
  );
};

export default DocumentRegisters;
